import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import AdminLayout from "./components/layout/AdminLayout";
import Orders from "./pages/Orders";
import SimSwap from "./pages/SimSwap";
import Customers from "./pages/Customers";
import SignIn from "./pages/SignIn";
import CreatePassword from "./pages/auth/CreateNewPassword";
import PageNotFound from "./pages/PageNotFound";
import ServerDownPage from "./pages/ServerDownPage";
import ProtectedRoute from "./components/layout/ProtectedRoute";
import { SessionProvider } from "./components/layout/SessionContext";
import PromoCode from "./pages/PromoCode";
import ManageUsers from "./pages/ManageUsers";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import Products from "./pages/Products";

const App = () => {

  return (
    <div className="app-container">
      <Router>
        <SessionProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/signin" />} />
            {/* SignIn route outside of AdminLayout */}
            <Route path="/signin" element={<SignIn />} />
            <Route path="/create-new-password" element={<CreatePassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* ServerDownPage for /server-down path */}
            <Route path="/server-down" element={<ServerDownPage />} />

            {/* AdminLayout wrapper for authenticated routes */}
            <Route
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/products" element={<Products />} />
              <Route path="/simswap" element={<SimSwap />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/promocode" element={<PromoCode />} />
              <Route path="/manageUsers" element={<ManageUsers />} />
            </Route>

            {/* Catch-all route for PageNotFound */}
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </SessionProvider>
      </Router>
    </div>
  );
};

export default App;
